<template>
  <v-layout my-4 id="logInPage" style="border-radius: 28px!important;display:flex!important;flex-direction:column!important;">
    <div class="py-4">
      <p class="display-1 font-italic font-weight-medium" style="color:white;margin-bottom:-4px;">{{ $t('loginPage.welcome-message.1') }}</p>
      <p class="font-italic headline font-weight-light" style="text-shadow:0px 2px 3px rgba(0,0,0,0.3);">
        <span style="color:white;">{{ $t('loginPage.welcome-message.2') }}</span>
        <span style="color:white;">{{ $t('loginPage.welcome-message.3') }}</span>
      </p>
      <v-img style="position:relative;margin:30px auto 30px auto;" :src="logoSrc" height="77px" contain width="433px"></v-img>
      <p class="ont-italic display-1 font-weight-light" style="text-shadow:0px 2px 3px rgba(0,0,0,0.3);">
        <span style="color:#b5b5b5;">{{ $t('loginPage.welcome-message.4') }}</span>
        <v-spacer></v-spacer>
        <span style="color:white;">{{ $t('loginPage.welcome-message.5') }}</span>
      </p>
    </div>
    <v-sheet style="display:flex;flex-direction:column;height:100%;min-width:400px;" class="custom-center border-main-content elevation-12 mx-auto">
      <div class="transparent">
        <p class="font-weight-medium headline my-4">{{ $t('loginPage.login') }}</p>
      </div>
      <form style="width:100%;" class="py-4 px-10">
        <div >
          <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-on:keyup.enter="connection" :label="$t('loginPage.txtbox-login')" v-model="id"></v-text-field>
          <br>
          <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-on:keyup.enter="connection" :label="$t('loginPage.txtbox-password')" type="password" v-model="password"></v-text-field>
          <div class="error" style="border-radius:50em; margin-bottom:20px;background-color: rgb(var(--connection-rgb))!important; color:white!important;" v-html="error"/>
          <v-btn x-large block outlined rounded class="title font-italic font-weight-medium custom-valid-btn connection" @click="connection">{{ $t('loginPage.connect-btn') }}</v-btn>
          <br>
          <br>
        </div>
      </form>
    </v-sheet>
    <a href="https://allsan.fr/" style="margin:50px auto 0px auto;" height="82px" contain width="192px">
      <v-img style="position:relative;" :src="poweredSrc" height="82px" contain width="192px"></v-img>
    </a>
   </v-layout>
</template>

<script>
import LoginService from '@/services/LoginService'
export default {
  name: 'Login',
  data () {
    return {
      id: '',
      password: '',
      language: navigator.language.split('-')[0],
      error: null,
      logoSrc: require('../assets/images/SanDisplay.png'),
      poweredSrc: require('../assets/images/powered_by_allsan.png')
    }
  },
  methods: {
    async connection () {
      try {
        const response = await LoginService.connection({
          id: this.id,
          password: this.password,
          language: this.language
        })
        this.$store.dispatch('setUser', response.data.user)
        this.$vuetify.theme.dark = this.$store.state.user.darkTheme
        sessionStorage.setItem('theme', this.$store.state.user.darkTheme ? 'dark' : 'light')
        if (response.data.user) {
          this.$router.replace({
            name: 'root'
          })        
        }
      } catch (error) {
        console.log(error)
        this.error = error.response.data.error
      }
    }/* ,
    async createAccount() {
       const response = await LoginService.register({
         aa: 'aa'
        })
        console.log(response)
    } */
  },
  mounted () {
    if (!localStorage.language) {
      localStorage.language = navigator.language.split('-')[0]
    }
    this.$root.$i18n.locale = localStorage.language
  }
}
</script>

<style scoped>
</style>
